export default "__VITE_ASSET__C3uAECfT__"